export enum IconNames {
  COMPANY = "business",
  PROPERTY = "domain", // home
  CONTRACTORS = "supervisor_account",
  USERS = "people",
  UNITS = "apartment",

  TAG = "label",
  PRIORITY = "priority_high",

  SETTINGS = "settings",
  PEN = "edit",
  DELETE = "delete",

  NAME = "abc",
}
